export default __webpack_public_path__ + "static/media/splitboard.eed25d15.jpg";